export const modifyTableData = data => data.map(item => {
    const {created_at, updated_at, account_name, api_key, api_secret, site_id, ...other} = item;
    return modifyEmptyTableData({...other, api_key, api_secret, site_id});
});

export const modifyEmptyTableData = objData => {
    const newValuesObj = {};
    Object.entries(objData).forEach(itm => {
        if (itm[1] === null) {
            newValuesObj[itm[0]] = '';
        } else {
            newValuesObj[itm[0]] = itm[1];
        }
    })
    return newValuesObj;
}
